module.exports = __webpack_public_path__ + "static/Databricks-54f9dc3d2a7191bee7b8d86fecfbee65.jpg";